import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useSession } from "../hooks/useSession";

interface AuthGuardProps {
  children: ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { data, isLoading, isError } = useSession();

  if (isLoading) {
    return (
      <main
        aria-busy="true"
        className="min-h-dvh flex items-center justify-center"
      >
        <p className="text-sm text-slate-400">Loading…</p>
      </main>
    );
  }

  if (isError || !data?.authenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
